import { useState, useEffect } from "react";
import { getPhotos } from "../services/api";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

const Home = () => {
  const [photos, setPhotos] = useState([]);
  const [selectedItem, setSelectedItem] = useState(0);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const data = await getPhotos("carousel");
        const randomized = [...data].sort(() => Math.random() - 0.5);
        setPhotos(randomized);
        setSelectedItem(0);
      } catch (err) {
        console.error("Error fetching photos:", err);
      }
    };

    fetchPhotos();
  }, []);

  const goPrev = () => {
    if (!photos.length) return;
    setSelectedItem((i) => (i - 1 + photos.length) % photos.length);
  };

  const goNext = () => {
    if (!photos.length) return;
    setSelectedItem((i) => (i + 1) % photos.length);
  };

  return (
    <div className="carousel-image-container">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showIndicators={false}
        showStatus={false}
        showArrows={false}
        interval={3000}
        dynamicHeight
        selectedItem={selectedItem}
        onChange={setSelectedItem}
      >
        {photos.map((photo, index) => (
          <div key={index} className="carousel-slide">
            <img src={photo.path} alt="" className="carousel-img" />
          </div>
        ))}
      </Carousel>

      {photos.length > 1 && (
        <div className="carousel-nav">
          <button
            type="button"
            className="carousel-nav-btn"
            onClick={goPrev}
            aria-label="Previous photo"
          >
            ‹
          </button>
          <button
            type="button"
            className="carousel-nav-btn"
            onClick={goNext}
            aria-label="Next photo"
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;
